import React from 'react';

interface SigningSuccessProps {
  onDone: () => void;
}

const SigningSuccess: React.FC<SigningSuccessProps> = ({ onDone }) => {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 24px',
      }}
    >
      <div
        style={{
          width: '72px',
          height: '72px',
          borderRadius: '50%',
          backgroundColor: '#ecfdf5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '24px',
        }}
      >
        <svg
          width="36"
          height="36"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#10b981"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>
      <h2
        style={{
          margin: '0 0 8px',
          fontSize: '22px',
          fontWeight: 700,
          color: '#1a1a2e',
          textAlign: 'center',
        }}
      >
        All documents signed!
      </h2>
      <p
        style={{
          margin: '0 0 32px',
          fontSize: '15px',
          color: '#6b7280',
          textAlign: 'center',
          lineHeight: '22px',
        }}
      >
        You've completed all required documents.
      </p>
      <button
        onClick={onDone}
        style={{
          width: '100%',
          maxWidth: '300px',
          padding: '16px',
          borderRadius: '12px',
          border: 'none',
          fontSize: '16px',
          fontWeight: 700,
          color: '#ffffff',
          backgroundColor: '#6366f1',
          cursor: 'pointer',
          minHeight: '52px',
        }}
      >
        Done
      </button>
    </div>
  );
};

export default SigningSuccess;
